import { defHttp } from '/@/utils/http/axios';
import {
  CreateParams,
  TeamListParams,
  Team,
  TeamUserList,
  ApproveParams,
  TeamMemberListResultModel,
  TeamListResultModel,
  Role,
  SwitchTeamResult,
  // Tag
  TagItem,
  CategoryItem,
  // TagResultModel,
  UserTag,
  AssignTag,
  responseUserGroupTagParams,
  subscribeParams,
  gradeParams,
  teamQuotaList,
  responseInvoiceParams,
  ISubscription,
  IUpcomingParams,
  IPaymentDetail,
  IGetSubscriptionParams,
  ITeamPlan,
  ISaveDriveParams,
  IDriveListParams,
  TeamSelectoinListParams,
} from '../model/teamModel';
import { BasicIdParams, BasicPageParams } from '/@/api/model/baseModel';
import { DriveEnum } from '/@/enums/businessEnum';
import { User } from '../../sys/model/userModel';

enum Api {
  USER = '/user',
  DATASET = '/dataset',
}

export const teamList = () =>
  defHttp.get<TeamListResultModel>({
    url: `${Api.USER}/team/list`,
  });
/**
 * @description: Get sample list value
 */
export const createTeamApi = (params: CreateParams) =>
  defHttp.post<any>(
    {
      url: `${Api.USER}/team/create`,
      params,
    },
    { isTransformResponse: false },
  );

export const sentEmailCodeApi = (params: { enterpriseEmail: string }) =>
  defHttp.post<any>(
    {
      url: `${Api.USER}/team/enterprise/email/code`,
      params,
    },
    { isTransformResponse: false },
  );

export const getTeamInfoApi = (params?: { teamId?: string }) =>
  defHttp.get<Team>({
    url: `${Api.USER}/team/get`,
    params,
  });

export const joinTeamApi = (params: { teamId: string | number }) =>
  defHttp.post<Team>({
    url: `${Api.USER}/team/member/join/${params.teamId}`,
  });

export const teamListApi = (params?: TeamListParams) =>
  defHttp.post<TeamMemberListResultModel>({
    url: `${Api.USER}/team/member/list`,
    params,
    timeout: 30 * 1000,
  });

// 可以查询到邀请了但是还没有加入的member
export const teamSelectionListApi = (params?: TeamSelectoinListParams) =>
  defHttp.post<User[]>({
    url: `${Api.USER}/team/member/selectionList`,
    params,
    timeout: 30 * 1000,
  });

export const approveListApi = (params) =>
  defHttp.get<TeamUserList>({
    url: `${Api.USER}/team/member/list/waitApproved`,
    params,
  });

export const approveActionApi = (params: ApproveParams) =>
  defHttp.post<TeamUserList>({
    url: `${Api.USER}/team/member/approve`,
    params,
  });

export const removeMemberActionApi = (params: { ids: (string | number)[] }) =>
  defHttp.post<TeamUserList>({
    url: `${Api.USER}/team/member/remove`,
    params,
  });

export const roleListApi = () =>
  defHttp.get<Role[]>({
    url: `${Api.USER}/role/find`,
  });

export const getTemplate = () =>
  defHttp.get<Role[]>({
    url: `${Api.USER}/team/export/sample`,
  });

export const importUser = (params) =>
  defHttp.uploadFile<any>(
    {
      url: `/api${Api.USER}/team/upload/invite`,
    },
    params,
  );

export const changeRoleApi = (params: { roleId: string | number; userId: string | number }) =>
  defHttp.post<undefined>({
    url: `${Api.USER}/role/changeRole`,
    params,
  });

export const inviteMemberApi = (params: {
  members: { email: string; roleId: string | number }[];
}) =>
  defHttp.post<{ roles: Role[] }>(
    {
      url: `${Api.USER}/team/member/invite`,
      params,
    },
    { errorMessageMode: 'message' },
  );

export const transferApi = (params: { roleId: string | number; userId: string | number }) =>
  defHttp.post<undefined>(
    {
      url: `${Api.USER}/role/transferOwner`,
      params,
    },
    {
      errorMessageMode: 'modal',
    },
  );

export const cancelInviteApi = (params: { ids: string[] | number[] }) =>
  defHttp.post<undefined>({
    url: `${Api.USER}/team/member/cancel`,
    params,
  });

export const switchTeam = (params: { id: number; autoSwitch?: number }) =>
  defHttp.get<SwitchTeamResult>({
    url: `${Api.USER}/team/switch/${params.id}`,
    params,
  });

export const teamPendingApi = (params?: TeamListParams) =>
  defHttp.get<TeamMemberListResultModel>({
    url: `${Api.USER}/team/member/pending/list`,
    params,
  });

export const disbandTeamApi = (params) =>
  defHttp.post<SwitchTeamResult>({
    url: `${Api.USER}/team/remove/${params.id}`,
  });

/** ------- Tag Start ------- */

/** 获取标签树 */
export const getTagTreeApi = () =>
  defHttp.get<CategoryItem[]>({
    url: `${Api.USER}/tag/tree`,
  });

/** 添加修改 TagTree */
export const createEditTagApi = (params: TagItem) =>
  defHttp.post<TagItem | CategoryItem>({
    url: `${Api.USER}/tag/save`,
    params,
  });

/** 删除 Tag | Category */
export const deleteTagApi = (params: BasicIdParams) =>
  defHttp.post<undefined>({
    url: `${Api.USER}/tag/delete/${params.id}`,
  });

/** 查询用户标签 */
export const getUserTagListApi = (params: { userIds: string }) =>
  defHttp.get<UserTag[]>({
    url: `${Api.USER}/tag/userTag/list`,
    params,
  });

/** 分配标签 */
export const assignTagApi = (params: AssignTag[]) =>
  defHttp.post<undefined>({
    url: `${Api.USER}/tag/assignTags`,
    params,
  });

/** ------- Tag End ------- */

/** 查询用户、分组、标签 */
export const getUserGroupTagApi = (params: { userId: string }) =>
  defHttp.get<responseUserGroupTagParams>({
    url: `${Api.USER}/user/groupTagInfo`,
    params,
  });

export const updateTeamApi = (params: any) =>
  defHttp.post<undefined>({
    url: `${Api.USER}/team/update`,
    params,
  });

export const checkExpire = (params: { teamId: string }) =>
  defHttp.get<any>({
    url: `${Api.USER}/team/checkExpire/${params.teamId}`,
    params,
  });

export const generateInviteLink = (params: { roleId: string }) =>
  defHttp.post<any>({
    url: `${Api.USER}/team/member/inviteLink`,
    params,
  });

/** ------- Billing Start ------- */

/** 创建订阅 */
export const subscribeApi = (params: subscribeParams) =>
  defHttp.post<any>({
    url: `${Api.USER}/billingSubscription/subscribe`,
    params,
  });

/** 取消订阅 */
export const unsubscribeApi = (params: { id: string | number; teamId: number | string }) =>
  defHttp.get<any>({
    url: `${Api.USER}/billingSubscription/cancel/${params.id}`,
    params,
  });

/** 恢复订阅 */
export const resumeUnsubscribeApi = (params: { id: string | number; teamId: number | string }) =>
  defHttp.get<any>({
    url: `${Api.USER}/billingSubscription/resume/${params.id}`,
    params,
  });

/** 升级套餐 */
export const upgrade = (params: gradeParams) =>
  defHttp.post<any>({
    url: `${Api.USER}/billingSubscription/upgrade`,
    params,
  });

/** 降级套餐 */
export const downgrade = (params: gradeParams) =>
  defHttp.post<any>({
    url: `${Api.USER}/billingSubscription/downgrade`,
    params,
  });

/** 查询订阅价格 */
export const getSubscriptionAmountApi = (params: IGetSubscriptionParams) =>
  defHttp.post<number>({
    url: `${Api.USER}/billingSubscription/getSubscriptionAmount`,
    params,
  });

/** 查询追加价格 */
export const getAdditionalModelCallsAmountApi = (params: {
  quota: string | number;
  subscriptionId?: number | string;
}) =>
  defHttp.get<number>({
    url: `${Api.USER}/billingInvoice/getAdditionalModelCallsAmount`,
    params,
  });

/** 增加额外的模型次数 */
export const appendModelCallApi = (params: { additionalModelCallsQuota: number }) =>
  defHttp.post<any>({
    url: `${Api.USER}/billingInvoice/addAdditionalModelCalls`,
    params,
  });

/** 升级时获取差价 */
export const getPriceDiff = (params: gradeParams) =>
  defHttp.post<any>({
    url: `${Api.USER}/billingSubscription/getPriceDiff`,
    params,
  });

/**  根据 teamId 查询订阅 */
export const getBillingSubscriptionApi = (params: { id: string | number }) =>
  defHttp.get<ISubscription>({
    url: `${Api.USER}/billingSubscription/${params.id}`,
  });

/** 获取团队配额 */
export const getTeamQuotaApi = () =>
  defHttp.get<teamQuotaList>({
    url: `${Api.USER}/teamQuota/current`,
  });

/** 分页查询 Invoice */
export const getInvoiceApi = (params: BasicPageParams) =>
  defHttp.get<responseInvoiceParams>({
    url: `${Api.USER}/billingInvoice/findByPage`,
    params,
  });

/** 查询支付详情 */
export const getPaymentDetailApi = () =>
  defHttp.get<IPaymentDetail>({
    url: `${Api.USER}/billingSubscription/getPaymentDetail`,
  });

/** 获取下一个自动扣款信息 */
export const getUpcomingApi = () =>
  defHttp.get<IUpcomingParams>({
    url: `${Api.USER}/billingSubscription/getUpcomingBilling`,
  });

/** 跳转用户修改支付信息页面 */
export const createCustomerPortalSession = () =>
  defHttp.post<any>({
    url: `${Api.USER}/billingSubscription/createCustomerPortalSession`,
  });

/** 查询team套餐 */
export const getTeamPlanApi = () =>
  defHttp.get<ITeamPlan>({
    url: `${Api.USER}/billingPlan/getTeamPlan`,
  });

/** 降级套餐 */
export const downgradeApi = () =>
  defHttp.post<any>({
    url: `${Api.USER}/billingSubscription/resetPlanToFreePlan`,
  });

/** ------- Billing End ------- */

/** ------- Drive Start ------- */
/** 获取存储列表 */
export const getDriveListApi = () =>
  defHttp.get<IDriveListParams[]>({
    url: `${Api.USER}/drive/authorize/list`,
  });
/** 校验重名 */
export const validateDriveNameApi = (params: { id?: string | number; name: string }) =>
  defHttp.get<boolean>({
    url: `${Api.USER}/drive/authorize/checkName`,
    params,
  });

/** 删除存储列表 */
export const deleteDriveApi = (params: { id: string }) =>
  defHttp.post<null>({
    url: `${Api.USER}/drive/authorize/delete/${params.id}`,
  });

/** 存储Drive信息 */
export const saveDriveApi = (params: ISaveDriveParams) =>
  defHttp.post<null>({
    url: `${Api.USER}/drive/authorize/save`,
    params,
    timeout: 20 * 1000,
  });

/** OAuth2初始化 */
export const startOAuth2Api = (params: { provider: DriveEnum }) =>
  defHttp.post<string>({
    url: `${Api.USER}/drive/authorize/start`,
    params,
    timeout: 120 * 1000,
  });

/** OAuth2初始化 */
export const cancelOAuth2Api = (params: { oauthRecordId: string }) =>
  defHttp.post<null>({
    url: `${Api.USER}/drive/authorize/cancel`,
    params,
  });

/** 获取OAuth2授权状态 */
export const getOAuth2StatusApi = (params: { oauthRecordId: string }) =>
  defHttp.get<string>(
    {
      url: `${Api.USER}/drive/authorize/status`,
      params,
    },
    {
      errorMessageMode: 'none',
    },
  );

/** 获取云端目录树 */
export const getDriveTreeApi = (params: {
  cloudStorageId?: string | number;
  provider: string;
  path?: string;
  cursor?: string;
}) =>
  defHttp.get({
    url: `${Api.DATASET}/cloud/storage/listFile`,
    params,
  });

/** ------- Drive End ------- */

export const getTaskResources = (params: { taskId: string | number }) =>
  defHttp.get<string[]>({
    url: `${Api.USER}/user/permission/task/${params.taskId}`,
    params,
  });
